module.exports = __webpack_public_path__ + "static/media/blog_grid_6.a09386c5.jpg";